import React from 'react';
import Leanding from '../../Pages/Leanding';
import About from '../../Pages/About';
import Support from '../../Pages/Support';
import Docs from '../../Pages/Docs';
import { Route, Switch } from 'react-router-dom';

export default function Main() {
    return(
        <React.Fragment>
            <Switch>
                <Route exact path="/" component={Leanding}/>
                <Route path="/about" component={About}/>
                <Route path="/support" component={Support}/>
                <Route path="/docs" component={Docs}/>
            </Switch>
        </React.Fragment>
    );
}